module.exports = __webpack_public_path__ + "img/jonder_white.c93b3106.png";